import React from 'react'
import { AccountChartStyle } from './AccountCharts.styled'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import Color from '../../common/ColorEnum';

ChartJS.register(ArcElement, Tooltip, Legend);

const AccountCharts = ({datasetIdKey,data={online:0,offline:0,snoozed:0},module=""}) => {
    const labelfunction=(tooltipItem)=>{
        const statusarr=["Online","Offline","Snooze"]
        const status=statusarr[tooltipItem.dataIndex]
        const message=`Active ${module} Reporting ${status} : ${tooltipItem.parsed}`
        return message
    }
  return (
    <AccountChartStyle>
        <p className='chartheading'>{module}</p>
        <div className='chartdiv'>
            <Doughnut 
                datasetIdKey={datasetIdKey}
            options={{
                plugins:{
                    tooltip:{
                        callbacks:{
                            label:labelfunction
                        }
                    }
                }
            }}
            data={{
                labels:["Online","Offline","Snooze"],
                fill:false,
                datasets:[
                    {
                        data:[data.online,data.offline,data.snoozed],
                        backgroundColor: [
                            `${Color.online}`,
                            `${Color.offline}`,
                            `${Color.snoozed}`
                        ],
                        hoverOffset: 4,
                    }
                ]
            }}/>
        </div>
    </AccountChartStyle>
  )
}

export default AccountCharts